import { useState } from "react";
import axios from "axios";
import { Plane, ShieldCheck, GraduationCap, Briefcase } from "lucide-react";
import { toast } from "react-toastify";
import ManufacturerVendor from "../vendorOnboarding/ManufacturerVendor";
import brand from "../../assets/image/png/brand.png";
import your from "../../assets/image/png/Your-Storefront.png";
import visibility from "../../assets/image/png/visibility.png";
import talent from "../../assets/image/png/talent-faster.png";
import sell from "../../assets/image/png/sell-directly.png";
import job from "../../assets/image/png/job-opening.png";
import bgImage from "../../assets/image/png/MainTop.png";
import DaasVendor from "./DaasVendor";
import InstituteVendor from "./InstituteVendor";
 
// const url =  "http://localhost:6002";
const url =  "https://api.droneplanet.in";
 
const SrField = ({
  id,
  type = "text",
  name,
  label,
  maxLength,
  error,
  value,
  onChange,
}) => (
  <div className="relative">
    <input
      id={id}
      type={type}
      name={name}
      placeholder=" "
      required
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      className="peer w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
    />
 
    <label
      htmlFor={id}
      className="absolute left-3 top-2.5 text-gray-400 text-sm bg-white px-1 cursor-text transition-all
      peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600
      peer-valid:-top-2 peer-valid:text-xs
      peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-sm"
    >
      {label}
    </label>
 
    {error && (
      <p className="text-red-500 text-xs mt-1">
        {error}
      </p>
    )}
  </div>
);
 
export default function DroneHero() {
  const [showForm, setShowForm] = useState(false);
  const [role, setRole] = useState("manufacturer");
  const [activeTab, setActiveTab] = useState("enterprises");
  const [otpModal, setOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
 
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });
 
  // Sales Rep form data (separate state)
const [srFormData, setSrFormData] = useState({
  name: "",
  phone: "",
  email: "",
  state: "",
  district: "",
  tehsil: "",
});
 
 
 
  const roleMap = {
    manufacturer: "Manufacturer",
    daas: "daasVendor",
    institute: "institute",
    salesrep: "salesRepresentative",
  };
 
  const [errors, setErrors] = useState({});
  const [srErrors, setSrErrors] = useState({});
 
  // --- Standard form handlers ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^\d*$/.test(value)) return;
    setFormData({ ...formData, [name]: value });
  };
 
  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    else if (!/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Phone number must be 10 digits";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email))
      newErrors.email = "Invalid email address";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      setLoading(true);
      const payload = {
        role: roleMap[role],
        name: formData.name,
        phoneNumber: formData.phone,
        email: formData.email,
      };
      const res = await axios.post(`${url}/registerInstitute`, payload);
      if (res.data.message === "OTP sent successfully") setOtpModal(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
 
  // --- Sales Rep form handlers ---
  const handleSrChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^\d*$/.test(value)) return;
    setSrFormData({ ...srFormData, [name]: value });
  };
 
  const validateSr = () => {
    let newErrors = {};
    if (!srFormData.name.trim()) newErrors.name = "Name is required";
    if (!srFormData.phone) newErrors.phone = "Phone number is required";
    else if (!/^\d{10}$/.test(srFormData.phone))
      newErrors.phone = "Phone number must be 10 digits";
    if (!srFormData.email) newErrors.email = "Email is required";
    else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(srFormData.email)
    )
      newErrors.email = "Invalid email address";
    if (!srFormData.state.trim()) newErrors.state = "State is required";
    if (!srFormData.district.trim()) newErrors.district = "District is required";
    if (!srFormData.tehsil.trim()) newErrors.tehsil = "Tehsil is required";
    setSrErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
const handleSrSubmit = async (e) => {
  e.preventDefault();
 
  if (!validateSr()) return;
 
  try {
    setLoading(true);
 
    const payload = {
      name: srFormData.name,
      phoneNumber: srFormData.phone,
      email: srFormData.email,
      state: srFormData.state,
      district: srFormData.district,
      tehsil: srFormData.tehsil,
    };
 
    const res = await axios.post(
      `${url}/registerSalesRepresentative`,
      payload
    );
 
    if (res.data.status === "success") {
      toast.success(
        `Registration successful. SRID: ${res.data.data.srid}`
      );
 
      setSrFormData({
        name: "",
        phone: "",
        email: "",
        state: "",
        district: "",
        tehsil: "",
      });
      setTimeout(() => {
        window.location.href = "https://app.droneplanet.in";
      }, 1500);
 
      setShowForm(false);
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message ||
      "Registration failed"
    );
  } finally {
    setLoading(false);
  }
};
 
  // --- OTP Verify ---
  const verifyOtp = async () => {
    try {
      if (otp.length !== 6) {
        toast.error("Please enter a valid 6 digit OTP");
        return;
      }
      const phoneNumber =
        role === "salesrep" ? srFormData.phone : formData.phone;
      const res = await axios.post(`${url}/otpVerify`, {
        phoneNumber,
        otp: otp.trim(),
      });
      if (res.data.status === "success") {
        setOtpModal(false);
        setFormData({ name: "", phone: "", email: "" });
        setSrFormData({
          name: "",
          phone: "",
          email: "",
          state: "",
          district: "",
          tehsil: "",
        });
        setOtp("");
        setShowForm(false);
        toast.success("Registration successful! Check your email for credentials.");
        setTimeout(() => {
          window.location.href = "https://app.droneplanet.in";
        }, 1500);
      } else {
        toast.error(res.data.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
    }
  };
 
  const features = [
    {
      icon: sell,
      title: "Sell Directly to Thousands",
      desc: "Connect with ready-to-buy drone enthusiasts who are looking for exactly what you offer.",
    },
    {
      icon: job,
      title: "Post Job Openings",
      desc: "Hire Engineers, Technicians & Sales Pros FAST from our pool of qualified candidates.",
    },
    {
      icon: brand,
      title: "Showcase Your Brand",
      desc: "Your Drones. Your Parts. Your Prices. Complete control over your product listings.",
    },
    {
      icon: visibility,
      title: "Get Instant Visibility",
      desc: "Join a platform BUILT for Drone Businesses and get noticed immediately.",
    },
    {
      icon: your,
      title: "Your Storefront. Your Rules.",
      desc: "No Middlemen. No Delays. Just SALES. Full control over your profits.",
    },
    {
      icon: talent,
      title: "Find Talent Faster",
      desc: "Hire skilled experts in hardware, software, design, R&D, and more. Thousands of applicants. One platform.",
    },
  ];
 
  const [billingCycle, setBillingCycle] = useState("annually");
  const pricing = {
    pro: billingCycle === "annually" ? 699 : 999,
    premium: billingCycle === "annually" ? 2099 : 2999,
    enterprise: billingCycle === "annually" ? 2799 : 3999,
  };
  const plans = [
    {
      title: "Pro",
      price: pricing.pro,
      features: [
        "100 leads /month",
        "20-30 Students",
        "Access to community support",
        "Basic profile listing",
        "Email insights & analytics",
        "Support response within 48 hours",
      ],
    },
    {
      title: "Premium",
      price: pricing.premium,
      popular: true,
      features: [
        "200 leads /month",
        "30-40 Students",
        "Priority email & call support",
        "Premium placement in listings",
        "Detailed performance analytics",
        "Lead scoring & filters",
        "Support response within 12 hours",
      ],
    },
    {
      title: "Enterprise",
      price: pricing.enterprise,
      features: [
        "350 leads /month",
        "40-50 Students",
        "Dedicated account manager",
        "Custom integrations",
        "Advanced analytics dashboard",
        "Full profile customization",
        "Support response within 4 hours",
      ],
    },
  ];
 
  const scrollToForm = () => {
    document.getElementById("form-section")?.scrollIntoView({ behavior: "smooth" });
  };
 
  // Floating label field helper for Sales Rep form
 
 
  const isSalesRep = role === "salesrep";
 
  return (
    <>
      <section
        className="w-full py-10 px-6 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="max-w-7xl mx-auto">
          {/* TOP SELECTOR */}
          <div className="flex justify-center mb-10">
            <div className="flex flex-wrap justify-center bg-white/70 backdrop-blur-md border border-gray-200 shadow-md rounded-xl p-1.5 gap-1.5">
              <button
                onClick={() => { setRole("manufacturer"); setShowForm(false); }}
                className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-lg font-medium transition-all ${
                  role === "manufacturer"
                    ? "bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <Plane size={14} /> Manufacturer
              </button>
              <button
                onClick={() => { setRole("daas"); setShowForm(false); }}
                className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-lg font-medium transition-all ${
                  role === "daas"
                    ? "bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <ShieldCheck size={14} /> DAAS
              </button>
              <button
                onClick={() => { setRole("institute"); setShowForm(false); }}
                className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-lg font-medium transition-all ${
                  role === "institute"
                    ? "bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <GraduationCap size={14} /> Institute
              </button>
              {/* NEW: Sales Representative button */}
              <button
                onClick={() => { setRole("salesrep"); setShowForm(false); }}
                className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-lg font-medium transition-all ${
                  role === "salesrep"
                    ? "bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <Briefcase size={14} /> Sales Rep
              </button>
            </div>
          </div>
 
          <div className="grid md:grid-cols-2 gap-10 items-center">
            {/* LEFT CONTENT */}
            <div>
              <h1 className="text-5xl font-bold leading-tight text-gray-900">
                Join The <span className="text-blue-600">Future</span> Of <br />
                Drone Technology
              </h1>
              <p className="text-gray-600 mt-6 text-lg">
                {isSalesRep
                  ? "Become a Sales Representative and help grow the drone ecosystem across India. Connect manufacturers, service providers, and educators in your region."
                  : "Register your organization and become part of the premier ecosystem connecting manufacturers, service providers, and educators in the drone industry."}
              </p>
              <div className="flex gap-6 mt-6 text-blue-600 font-medium">
                {isSalesRep ? (
                  <>
                    <span>✔ Region-Based</span>
                    <span>✔ Incentives</span>
                    <span>✔ Unique SRID</span>
                  </>
                ) : (
                  <>
                    <span>✔ Global Network</span>
                    <span>✔ Industry Insights</span>
                    <span>✔ Business Growth</span>
                  </>
                )}
              </div>
            </div>
 
            {/* RIGHT CARD — flip animation */}
            <div className="flex justify-center perspective-1000">
              <div
                className={`relative w-full max-w-md transition-transform duration-700 transform-style-preserve-3d ${
                  showForm ? "rotate-y-180" : ""
                }`}
                style={{ minHeight: "420px", height: showForm ? "auto" : "420px" }}
              >
                {/* FRONT CARD */}
                <div
                  onClick={() => setShowForm(true)}
                  className="absolute w-full h-full backface-hidden bg-white/80 backdrop-blur-lg border border-white/40 rounded-2xl shadow-xl p-10 cursor-pointer flex flex-col justify-center items-center transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 group"
                >
                  <div className="relative mb-6">
                    <div className="absolute inset-0 bg-blue-500 blur-xl opacity-30 rounded-full animate-pulse"></div>
                    <div className="relative w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-r from-blue-500 to-purple-500 text-white text-3xl shadow-lg">
                      {isSalesRep ? <Briefcase size={36} /> : "✓"}
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold mb-2 text-center text-gray-800">
                    {isSalesRep ? "Sales Representative" : "Seamless Registration"}
                  </h3>
                  <p className="text-gray-500 text-center mb-4">
                    {isSalesRep
                      ? "Join as a regional sales partner and grow with us."
                      : "Unlock access to the global drone network."}
                  </p>
                  <span className="text-blue-600 font-semibold relative">
                    Click here to register
                    <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-blue-500 transition-all duration-300 group-hover:w-full"></span>
                  </span>
                </div>
 
                {/* BACK FORM */}
                <div
                  className="absolute inset-0 rotate-y-180 backface-hidden bg-white/90 backdrop-blur-lg border border-white/40 rounded-2xl shadow-xl p-8 overflow-y-auto flex flex-col justify-start"
                >
                  <h3 className="text-xl font-semibold mb-5 text-center text-gray-800">
                    {isSalesRep ? "Sales Representative Registration" : "Register Your Organization"}
                  </h3>
 
                  {/* ── SALES REP FORM ── */}
                  {isSalesRep ? (
                    <form className="space-y-3" onSubmit={handleSrSubmit}>
                      {/* Row 1: Name + Phone */}
                      <div className="grid grid-cols-2 gap-3">
                        <SrField
                          id="sr-name"
                          name="name"
                          label="Full Name"
                          value={srFormData.name}
                          onChange={handleSrChange}
                          error={srErrors.name}
                        />
                        <SrField id="sr-phone" type="tel" name="phone" label="Phone Number" maxLength={10} value={srFormData.phone} onChange={handleSrChange} error={srErrors.phone} />
                      </div>
                      {/* Row 2: Email + State */}
                      <div className="grid grid-cols-2 gap-3">
                        <SrField id="sr-email" type="email" name="email" label="Email Address" value={srFormData.email} onChange={handleSrChange} error={srErrors.email} />
                        <SrField id="sr-state" name="state" label="State" value={srFormData.state} onChange={handleSrChange} error={srErrors.state} />
                      </div>
                      {/* Row 3: District + Tehsil */}
                      <div className="grid grid-cols-2 gap-3">
                        <SrField id="sr-district" name="district" label="District" value={srFormData.district} onChange={handleSrChange} error={srErrors.district} />
                        <SrField id="sr-tehsil" name="tehsil" label="Tehsil" value={srFormData.tehsil} onChange={handleSrChange} error={srErrors.tehsil} />
                      </div>
 
                      <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 transition-all shadow-md hover:shadow-lg disabled:opacity-60"
                      >
                        {loading ? "Submitting..." : "Submit Registration"}
                      </button>
                    </form>
                  ) : (
                    /* ── STANDARD FORM (Manufacturer / DAAS / Institute) ── */
                    <form className="space-y-5" onSubmit={handleSubmit}>
                      {/* NAME */}
                      <div className="relative">
                        <input
                          id="name"
                          type="text"
                          name="name"
                          placeholder=" "
                          required
                          value={formData.name}
                          onChange={handleChange}
                          className="peer w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                        />
                        <label
                          htmlFor="name"
                          className="absolute left-3 top-2.5 text-gray-400 text-sm bg-white px-1 cursor-text transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600 peer-valid:-top-2 peer-valid:text-xs peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-sm"
                        >
                          Name
                        </label>
                        {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                      </div>
                      {/* PHONE */}
                      <div className="relative">
                        <input
                          id="phone"
                          type="tel"
                          name="phone"
                          placeholder=" "
                          required
                          value={formData.phone}
                          onChange={handleChange}
                          maxLength={10}
                          className="peer w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                        />
                        <label
                          htmlFor="phone"
                          className="absolute left-3 top-2.5 text-gray-400 text-sm bg-white px-1 cursor-text transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600 peer-valid:-top-2 peer-valid:text-xs peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-sm"
                        >
                          Phone Number
                        </label>
                        {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                      </div>
                      {/* EMAIL */}
                      <div className="relative">
                        <input
                          id="email"
                          type="email"
                          name="email"
                          placeholder=" "
                          required
                          value={formData.email}
                          onChange={handleChange}
                          className="peer w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                        />
                        <label
                          htmlFor="email"
                          className="absolute left-3 top-2.5 text-gray-400 text-sm bg-white px-1 cursor-text transition-all peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600 peer-valid:-top-2 peer-valid:text-xs peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-sm"
                        >
                          Email Address
                        </label>
                        {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                      </div>
                      <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 transition-all shadow-md hover:shadow-lg disabled:opacity-60"
                      >
                        {loading ? "Submitting..." : "Submit Registration"}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* Dynamic Vendor Section */}
      {role === "manufacturer" && (
        <ManufacturerVendor features={features} scrollToForm={scrollToForm} />
      )}
      {role === "daas" && (
        <DaasVendor
          scrollToForm={scrollToForm}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}
      {role === "institute" && (
        <InstituteVendor
          scrollToForm={scrollToForm}
          billingCycle={billingCycle}
          setBillingCycle={setBillingCycle}
          plans={plans}
        />
      )}
 
      {/* OTP Modal — only for Manufacturer, DAAS, Institute */}
      {otpModal && !isSalesRep && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white/90 backdrop-blur-xl border border-white/30 rounded-2xl p-8 w-[380px] shadow-2xl animate-fadeIn">
            <h3 className="text-xl font-semibold text-gray-800 text-center mb-2">
              Verify OTP
            </h3>
            <p className="text-sm text-gray-500 text-center mb-6">
              We've sent a verification code to
              <span className="block font-medium text-gray-700 mt-1">
                {isSalesRep ? srFormData.phone : formData.phone}
              </span>
            </p>
            <input
              type="text"
              placeholder="••••••"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              maxLength={6}
              className="w-full border border-gray-300 rounded-xl px-4 py-3 text-center text-xl tracking-[8px] font-semibold outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition mb-6"
            />
            <button
              onClick={verifyOtp}
              disabled={loading || otp.length !== 6}
              className="w-full py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 shadow-lg hover:shadow-xl transition-all duration-300 disabled:opacity-60"
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
            <button
              onClick={() => setOtpModal(false)}
              className="w-full mt-3 py-2 rounded-xl border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}